export default class Formats {
  static readonly DATE_FORMAT = 'dd-MM-yyyy'
  static readonly DATE_MOMENT_FORMAT = 'DD-MM-YYYY'
  static readonly DATE_SERVER_FORMAT = "yyyy-MM-dd HH:mm:ss.fff";
  static readonly DATE_MOMENT_SERVER_FORMAT = "YYYY-MM-DD HH:mm:ss.SSS";
  static readonly DATE_PARSE_FORMAT = [this.DATE_SERVER_FORMAT, "yyyy-MM-dd HH:mm:ss", "dd/MM/yyyy", "dd-MM-yyyy", "dd-MM-yy", "dd/MM/yyyy", "dd/MM/yy", "ddMMyyyy", "ddMMyy", "ddMM"];
}
